import React from "react";
import { Menu } from "antd";
import { Link, useHistory } from "react-router-dom";
import "./Admin.scss";

const { SubMenu } = Menu;
const AdminMenu = () => {
	const history = useHistory();
	const {
		location: { pathname },
	} = history;

	let selectedKey = pathname;
	let openKey = null;
	if (selectedKey.includes("survey-categories")) {
		selectedKey = "/survey-categories";
	} else if (selectedKey.includes("questions")) {
		selectedKey = "/questions";
	} else if (selectedKey.includes("surveys")) {
		selectedKey = "/surveys";
	} else if (selectedKey.includes("mobile-versions")) {
		selectedKey = "/mobile-versions";
	} else if (selectedKey.includes("shipping-labels")) {
		selectedKey = "/shipping-labels";
	} else if (selectedKey.includes("spin-the-wheel/games")) {
		selectedKey = "/games";
		openKey = "/spin-the-wheel";
	} else if (selectedKey.includes("spin-the-wheel/game-messages")) {
		selectedKey = "/game-messages";
		openKey = "/spin-the-wheel";
	} else if (selectedKey.includes("spin-the-wheel/rates")) {
		selectedKey = "/rates";
		openKey = "/spin-the-wheel";
	} else if (selectedKey.includes("spin-the-wheel/rewards")) {
		selectedKey = "/rewards";
		openKey = "/spin-the-wheel";
	} else if (selectedKey.includes("spin-the-wheel/overview")) {
		selectedKey = "/overview";
		openKey = "/spin-the-wheel";
	} else if (selectedKey.includes("spin-the-wheel/number-of-spins")) {
		selectedKey = "/number-of-spins";
		openKey = "/spin-the-wheel";
	} else if (selectedKey.includes("notifications")) {
		selectedKey = "/notifications";
	} else if (selectedKey.includes("maintenances")) {
		selectedKey = "/maintenances";
	} else {
		selectedKey = ["/admins"];
	}

	const onSelect = ({ key }) => {
		if (key === "/games") {
			openKey = "/spin-the-wheel";
		} else {
			openKey = key;
		}
	};
	return (
		<Menu
			className="MainMenuSme"
			defaultOpenKeys={[openKey]}
			defaultSelectedKeys={[selectedKey]}
			onSelect={onSelect}
			mode="inline"
		>
			<Menu.Item key="/admins">
				<Link to="/admins">Admins</Link>
			</Menu.Item>
			<Menu.Item key="/questions">
				<Link to="/questions">Questions</Link>
			</Menu.Item>
			<Menu.Item key="/survey-categories">
				<Link to="/survey-categories">Survey Categories</Link>
			</Menu.Item>
			<Menu.Item key="/surveys">
				<Link to="/surveys">Surveys</Link>
			</Menu.Item>
			<Menu.Item key="/mobile-versions">
				<Link to="/mobile-versions">Mobile Versions</Link>
			</Menu.Item>
			<Menu.Item key="/shipping-labels">
				<Link to="/shipping-labels">Shipping Labels</Link>
			</Menu.Item>
			<SubMenu
				key="/spin-the-wheel"
				title="Spin The Wheel"
				triggerSubMenuAction="hover"
			>
				<Menu.Item key="/overview">
					<Link to="/spin-the-wheel/overview">Overview</Link>
				</Menu.Item>
				<Menu.Item key="/games">
					<Link to="/spin-the-wheel/games">Games</Link>
				</Menu.Item>
				<Menu.Item key="/game-messages">
					<Link to="/spin-the-wheel/game-messages">Game Messages</Link>
				</Menu.Item>
				<Menu.Item key="/rewards">
					<Link to="/spin-the-wheel/rewards">Rewards</Link>
				</Menu.Item>
				<Menu.Item key="/rates">
					<Link to="/spin-the-wheel/rates">Rates</Link>
				</Menu.Item>
				<Menu.Item key="/number-of-spins">
					<Link to="/spin-the-wheel/number-of-spins">Number of Spins</Link>
				</Menu.Item>
			</SubMenu>
			<Menu.Item key="/notifications">
				<Link to="/notifications">Notifications</Link>
			</Menu.Item>
			<Menu.Item>
				<Link to="/bottom-banners">Bottom Banners</Link>
			</Menu.Item>
			<Menu.Item key="/maintenances">
				<Link to="/maintenances">Maintenances</Link>
			</Menu.Item>
		</Menu>
	);
};

export default AdminMenu;
